import { getClientDocumentById } from "api/customers";
import { getS3SignedUrl } from "utils/getS3SignedUrl";

export const prepareChimeAttachment = async (metadata, cognitoId) => {
  try {
    const doc = await getClientDocumentById(metadata.attachmentId);
    const filename = doc?.data?.document?.filename;
    const displayFilename = doc?.data?.document?.display_filename;
    const ext = displayFilename?.split(".").pop()?.toLowerCase();
    const isImageFile = /^(jpg|jpeg|png|gif|webp|bmp|svg)$/.test(ext);
    metadata.attachmentUrl = await getS3SignedUrl(filename, cognitoId, 10800);
    metadata.filename = displayFilename;
    metadata.isImage = isImageFile;
  } catch (err) {
    console.error("Error fetching document or generating URL:", err);
  }
  return metadata;
};
